export class EmailSignatureApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEmailSignature({ companyId }) {
    return this.#http.get(`/api/email-signature-templates/${companyId}`);
  }

  async createEmailSignature({ companyId, ...body }) {
    return this.#http.post(`/api/email-signature-templates/${companyId}`, body);
  }

  async updateEmailSignature({ companyId, ...body }) {
    return this.#http.put(`/api/email-signature-templates/${companyId}`, body);
  }

  async uploadEmailSignatureFile({ companyId, formData }) {
    return this.#http.post(`/api/email-signature-templates/${companyId}/resources`, formData, {
      'Content-Type': 'multipart/form-data',
    });
  }
}
